import { CartAddEvent, CartUpdateEvent } from '@theme/events';

document.addEventListener('ajaxProduct:added', async (event) => {
  const detail = event.detail || {};
  const items = detail.product?.items;
  const variantId = items?.[0]?.id || detail.product?.id || detail.product?.variant_id;
  if (!variantId) return;

  document.dispatchEvent(
    new CartAddEvent({}, String(variantId), {
      source: 'legacy-expanse-quick-add',
      itemCount: Number(items?.[0]?.quantity || 1),
      variantId: String(variantId),
    })
  );

  const cartUrl = window.theme?.routes?.cart;
  if (!cartUrl) return;

  try {
    const response = await fetch(cartUrl, { credentials: 'same-origin' });
    if (!response.ok) return;
    const cart = await response.json();
    document.dispatchEvent(new CartUpdateEvent(cart, '', { source: 'legacy-expanse-quick-add' }));
  } catch (_error) {
    // Cart refresh is best-effort; add event above still updates the bubble.
  }
});
